// import axios from "@/axios";
import { mapCaseAccessData, checkUserAccessForAllCases } from "../utils";
import {
  fetchWorkAllocUsers,
  fetchWorkAllocGroups,
  fetchClientUsers,
  fetchCaseNotesUsers,
  fetchClientList,
  fetchMultipleWorkAllocUsers,
  fetchMultipleWorkAllocGroups,

} from "../services";

export const CaseEntitiesStore = {
  namespaced: true,

  state: {
    caseAccessData: {
      users: [],
      groups: [],
    },
    multipleCaseAccessData: {
      users: [],
      groups: [],
    },
    rawMultipleCaseAccessData: {
      users: [],
      groups: [],
    },
    caseNotesUsers: {},
    clientList: []
  },

  getters: {
    getCaseAccessData: state => state.caseAccessData,
    getMultiCaseAccessData:  state => state.multipleCaseAccessData,
    getRawMultiCaseAccessData: state => state.rawMultipleCaseAccessData,
    getRawMultiCaseAccessDataMap: (_, getters) => {
      const data = getters.getRawMultiCaseAccessData;
      const result = {};

      for (const type in data) {
        if (!(type in result)) {
          result[type] = {};
        }

        for (const caseId in data[type]) {
          result[type][caseId] = data[type][caseId].reduce((acc, item) => {
            acc[item.id] = item;
            return acc;
          }, {});
        }
      }

      return result;
    },
    getTenantUsersWithCaseAccess: state => state.caseNotesUsers?.tenant_users ?? [],
    getClientUsers: state => state.clientUsers,
    getClientUsersWithCaseAccess: state => state.caseNotesUsers?.client_users ?? [],
    getClientList: state => state.clientList,
    getTenantClient: state => (clientId) => {
      return state.clientList.find(el => el.id === clientId)
    }
  },

  mutations: {
    SET_CASE_ACCESS_DATA(state, { key, value }) {
      state.caseAccessData[key] = value
    },
    SET_MULTIPLE_CASE_ACCESS_DATA(state, { key, value }) {
      state.multipleCaseAccessData[key] = value
    },
    SET_RAW_MULTIPLE_CASE_ACCESS_DATA(state, { key, value }) {
      state.rawMultipleCaseAccessData[key] = value
    },
    SET_CLIENT_USERS(state, payload) {
      state.clientUsers = payload;
    },
    SET_CASE_NOTES_USERS(state, payload) {
      state.caseNotesUsers = payload;
    },
    SET_CLIENT_LIST(state, payload) {
      state.clientList = payload;
    }
  },

  actions: {
    fetchCaseAccessData: async({commit}, caseId) => {
      try {
        const [userData, groupData] = await Promise.all([
          fetchWorkAllocUsers(caseId),
          fetchWorkAllocGroups(caseId)
        ]);

        commit("SET_CASE_ACCESS_DATA", { key: "users", value: mapCaseAccessData(userData ?? []) });
        commit("SET_CASE_ACCESS_DATA", { key: "groups", value: mapCaseAccessData(groupData ?? []) });
      } catch(e) {
        console.error(e);
      }
    },

    fetchMultipleCaseAccessData: async({ commit }, caseIds) => {
      try {
        const [userData, groupData] = await Promise.all([
          fetchMultipleWorkAllocUsers(caseIds),
          fetchMultipleWorkAllocGroups(caseIds)
        ]);

        commit("SET_MULTIPLE_CASE_ACCESS_DATA", { key: "users", value: checkUserAccessForAllCases(userData ?? []) });
        commit("SET_MULTIPLE_CASE_ACCESS_DATA", { key: "groups", value: checkUserAccessForAllCases(groupData ?? []) });

        commit("SET_RAW_MULTIPLE_CASE_ACCESS_DATA", { key: "users", value: userData ?? [] });
        commit("SET_RAW_MULTIPLE_CASE_ACCESS_DATA", { key: "groups", value: groupData ?? [] });
      } catch(e) {
        console.error(e);
      }
    },

    fetchClientUsers: async({ commit }, clientId) => {
      try {
        const data = await fetchClientUsers(clientId);
        commit("SET_CLIENT_USERS", data ?? []);
      } catch(e) {
        console.error(e);
      }
    },

    fetchCaseNotesUsers: async({ commit }, params) => {
      try {
        const data = await fetchCaseNotesUsers(params.clientId, params.caseId);
        commit("SET_CASE_NOTES_USERS", data ?? {});
      } catch(e) {
        console.error(e);
      }
    },

    fetchClientsInfo: async({ commit, rootGetters }, clientId) => {
      try {
        const { data } = await fetchClientList({
          tenant_id: rootGetters.getTenantId,
          client_id: [clientId]
        });
        commit("SET_CLIENT_LIST", data ?? []);
      } catch(e) {
        console.error(e);
      }
    },

    resetMultipleCaseAccessData({ commit }) {
      commit("SET_MULTIPLE_CASE_ACCESS_DATA", { key: "users", value: [] });
      commit("SET_MULTIPLE_CASE_ACCESS_DATA", { key: "groups", value: [] });
      commit("SET_RAW_MULTIPLE_CASE_ACCESS_DATA", { key: "users", value: [] });
      commit("SET_RAW_MULTIPLE_CASE_ACCESS_DATA", { key: "groups", value: [] });
    }
  },
};
